import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import {
  b2bOrB2cOptionsArray,
  smsChatWhatsappOptionsArray,
} from './SharedConstants';

// The phone page is also used as the video page
const phonePages = [
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Phone && item.TypeCode != ServiceTypeEnum.Video,
    fields: [
      {
        fieldName: 'InteractionRequired',
        label: 'Is interaction required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ProductOrServiceInquiry',
        label: 'Product or Service Inquiry?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Phone && item.TypeCode != ServiceTypeEnum.Video,
    fields: [
      {
        fieldName: 'B2borB2c',
        label: 'B2B or B2C?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: b2bOrB2cOptionsArray,
      },
      {
        fieldName: 'CallerIdNeeded',
        label: "Does the Client's Phone Have Caller ID?",
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'B2B Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Phone && item.TypeCode != ServiceTypeEnum.Video,
    fields: [
      {
        fieldName: 'FictiosWebsiteCreationNeeded',
        label: 'Fictious Website Creation needed',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'IsBusinessInformationRequired',
        label: 'Is Business Information required',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'BusinessInformationDescription',
        label: 'If Yes, please describe',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  {
    label: 'B2C Demographics',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Phone && item.TypeCode != ServiceTypeEnum.Video,
    fields: [
      {
        fieldName: 'MinAge',
        label: 'Minimum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxAge',
        label: 'Maximum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'OtherDemographicRequirements',
        label: 'Other Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  {
    label: 'Shop Validation',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Phone && item.TypeCode != ServiceTypeEnum.Video,
    fields: [
      {
        fieldName: 'NumScreenshotsRequired',
        label: 'Number of Screenshots Required',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'SmsweChatWhatsappScreenshots',
        label: 'SMS, We Chat, or WhatsApp Screenshots Required?',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: smsChatWhatsappOptionsArray,
      },
      {
        fieldName: 'VoicemailTimeStampScreenshot',
        label: 'Voicemail Time Stamp Screenshot',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'NumCallAttemptsPerEval',
        label: 'No. of call attempts per Evaluation',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'OtherPhotosDesc',
        label: 'Describe other Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  {
    label: 'Questionnaire',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Phone && item.TypeCode != ServiceTypeEnum.Video,
    fields: [
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'TranslationProvided',
        label: 'Translation of Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription, // TODO:
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
      {
        fieldName: 'GuidelinesProvided',
        label: 'Guidelines Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'Purchase',
    hide: (item) => item.TypeCode != ServiceTypeEnum.Phone && item.TypeCode != ServiceTypeEnum.Video,
    fields: [
      {
        fieldName: 'PhonePurchaseRequired',
        label: 'Over the Phone Purchase Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseDesc',
        label: 'Please Describe Purchase',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'ReimbursementRequired',
        label: 'Reimbursement Requirement?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseReimbursed',
        label: 'Purchase Reimbursed by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseIncluded',
        label: 'Purchase NOT Reimbursed by BARE or Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
];

export default phonePages;
